// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import CryptoJS from 'crypto-js'

import VueParticles from 'vue-particles'

// 引入全局存储
import store from '@/store'

import myCharts from './components/utils/myCharts.js'

Vue.use(CryptoJS)

Vue.use(VueParticles)
Vue.use(myCharts)

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$mStore = store

Vue.prototype.$base64Img = (imageFile, callback, errorCallback) => {
  try {
    let reader = new FileReader()
    reader.readAsDataURL(imageFile)
    reader.onload = function (e) {
      if (callback) {
        let base64Str = e.target.result
        callback(base64Str)
      }
    }
  } catch (error) {
    console.error(error)
    if (errorCallback) {
      errorCallback(error)
    }
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js